import { history } from '../_helpers/history';
import { httpClient } from '../_helpers'
import { IOutstandingBooking, IUser, IVerifyToken } from '../interfaces/app.interface';

const baseUrl = process.env.REACT_APP_API_URL;

export const authService = {
  login,
  loginFB,
  loginG,
  logout,
  me,
  register,
  requestResetPassword,
  resetPassword,
  confirmResetPasswordCode,
  verifyEmail,
  getOutstandingBookings,
  verifyToken,
  refreshToken
};

/**
 * login by user/pass
 * @returns
 */
async function login(username: string, password: string) {
  return httpClient.post(`${baseUrl}/auth/login`, { username, password })
}

/**
 * call api to verify facebook token, then get jwt token of our api
 * @returns
 */
async function loginFB(tokenFB: string) {
  return httpClient.post(`${baseUrl}/auth/loginFB`, { tokenFB: tokenFB })
}

/**
 * call api to verify google token, then get jwt token of our api
 * @returns
 */
async function loginG(tokenG: string) {
  return httpClient.post(`${baseUrl}/auth/loginG`, { tokenG: tokenG });
}

// async function apiAuthenticate(accessToken: string) {
//   // authenticate with the api using a facebook access token,
//   // on success the api returns an account object with a JWT auth token
//   const response = await axios.post(`${baseUrl}/authenticate`, { accessToken });
//   const account = response.data;
//   startAuthenticateTimer();
//   return account;
// }

async function logout() {
  // revoke app permissions to logout completely because FB.logout() doesn't remove FB cookie
  window.FB.api('/me/permissions', 'delete', null, () => window.FB.logout());

  return httpClient.post(`${baseUrl}/auth/logout`, {});
  // stopAuthenticateTimer();
  // accountSubject.next(null);
  // history.push('/login');
}

async function me() {
  return httpClient.get<IUser>(`${baseUrl}/auth/me`);
}

async function getOutstandingBookings() {
  return httpClient.get<IOutstandingBooking[]>(`${baseUrl}/auth/outstanding-bookings`);
}

async function register(data: any) {
  return httpClient.post(`${baseUrl}/auth/register`, data);
}

async function requestResetPassword(data: any) {
  return httpClient.post(`${baseUrl}/auth/request-reset-password`, data);
}

async function confirmResetPasswordCode(data: any) {
  return httpClient.post(`${baseUrl}/auth/confirm-reset-password-code`, data);
}

async function resetPassword(data: any) {
  return httpClient.post(`${baseUrl}/auth/reset-password`, data);
}

async function verifyEmail(data: any) {
  return httpClient.post(`${baseUrl}/auth/verify-email`, data);
}

async function refreshToken(refresh_token: string) {
  return httpClient.get(`${baseUrl}/auth/refresh`, {
    headers: {
      refreshToken: refresh_token
    }
  });
}

/**
 * login by token
 * @returns
 */
async function verifyToken(data: IVerifyToken) {
  return httpClient.post(`${baseUrl}/auth/verify-token`, data)
}


// function getAll() {
//   return axios.get(baseUrl)
//     .then(response => response.data);
// }

// function getById(id: string) {
//   return axios.get(`${baseUrl}/${id}`)
//     .then(response => response.data);
// }


// // helper methods

// let authenticateTimeout: any;

// function startAuthenticateTimer() {
//   // parse json object from base64 encoded jwt token
//   const jwtToken = JSON.parse(atob(accountSubject.value.token.split('.')[1]));

//   // set a timeout to re-authenticate with the api one minute before the token expires
//   const expires = new Date(jwtToken.exp * 1000);
//   const timeout = expires.getTime() - Date.now() - (60 * 1000);
//   const { accessToken } = window.FB.getAuthResponse();
//   authenticateTimeout = setTimeout(() => apiAuthenticate(accessToken), timeout);
// }

// function stopAuthenticateTimer() {
//   // cancel timer for re-authenticating with the api
//   clearTimeout(authenticateTimeout);
// }
